<template>
  <div id="contact-search-and-list">
    <div id="contact-input-wrapper">
      <Input
        class="scs-input"
        heading="Email Address"
        placeholder="samiam@email.com"
        @scs-input="emailInput"
      />
      <Input
        class="scs-input"
        heading="First Name"
        placeholder="Sam"
        @scs-input="firstNameInput"
      />
      <Input
        class="scs-input"
        heading="Last Name"
        placeholder="Doe"
        @scs-input="lastNameInput"
      />
      <Input
        class="scs-input"
        heading="Phone Number"
        placeholder="(123) 456-7890"
        @scs-input="phoneNumberInput"
      />
    </div>
    <div id="contact-search-results">
      <contact-search-item
        v-if="chosenContact"
        :contact="chosenContact"
        :source="chosenContact.source"
        :selected="true"
        :showSource="true"
        @click="removeContact(chosenContact)"
      />
      <contact-search-item
        v-for="(contact, index) in ownedContacts"
        :key="index"
        :contact="contact"
        source="db"
        :selected="false"
        :showSource="true"
        @click="selectOwnedContact(contact, index)"
      />
      <contact-search-item
        v-for="(contact, index) in cognitoSearch"
        :key="index"
        :contact="contact"
        source="search"
        :selected="false"
        :showSource="true"
        @click="selectGlobalContact(contact, index)"
      />
    </div>
  </div>
</template>
<script>
import Input from "../../../../Components/Elements/Input.vue";

import ContactSearchItem from "../../../../Components/UI/ListItems/Contact/Search.vue";

export default {
  data() {
    return {
      emailSearchTerm: undefined,
      timer: undefined,
      loading: true,
      cognitoSearch: undefined,
      ownedContacts: [],
    };
  },
  methods: {
    async emailInput(value) {
      this.emailSearchTerm = value;
      this.$emit("email-input", value);
      this.ownedContacts = this.ownedContacts.filter((x) => {
        if (this.emailSearchTerm) {
          return x.email
            ? x.email.toLowerCase().includes(this.emailSearchTerm.toLowerCase())
            : false;
        } else {
          return true;
        }
      });
      this.loading = true;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => {
        if (value.length === 0) {
          this.ownedContacts = this.$store.getters.contacts;
        }
      }, 300);
    },
    firstNameInput(value) {
      this.$emit("first-name-input", value);
    },
    lastNameInput(value) {
      this.$emit("last-name-input", value);
    },
    phoneNumberInput(value) {
      this.$emit("phone-number-input", value);
    },
    processCognitoSearchResults(result) {
      let attributes = {};
      result.Attributes.forEach((att) => {
        attributes[att.Name] = att.Value;
      });
      return { ...result, ...attributes };
    },
    removeContact() {
      if (this.chosenContact.source === "db") {
        this.ownedContacts.unshift(this.chosenContact);
      } else {
        this.cognitoSearch.unshift(this.chosenContact);
      }
      this.$emit("remove-contact");
    },
    selectOwnedContact(contact, index) {
      this.ownedContacts.splice(index, 1);
      contact.source = "db";
      this.$emit("add-contact", contact);
    },
    selectGlobalContact(contact, index) {
      this.cognitoSearch.splice(index, 1);
      contact.source = "search";
      this.$emit("add-contact", contact);
    },
  },
  async created() {
    this.ownedContacts = this.$store.getters.contacts;
  },
  components: {
    Input,

    ContactSearchItem,
  },
  props: ["chosenContact"],
  emits: [
    "email-input",
    "first-name-input",
    "last-name-input",
    "phone-number-input",
    "add-contact",
    "remove-contact",
  ],
};
</script>
<style scoped>
@media screen {
  #contact-search-and-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #contact-input-wrapper {
    width: 100%;
    min-width: 100%;
    padding: 50px;
    box-sizing: border-box;
  }

  .scs-input {
    width: 100%;
  }

  #contact-search-results {
    padding: 5px 25px;
    /* width: 100%; */
    box-sizing: border-box;
    height: 350px;
    overflow: scroll;
  }
  @media (min-width: 800px) {
    #contact-search-and-list {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    #contact-input-wrapper {
      width: 40%;
      min-width: 40%;
      padding: 50px;
      border-right: 2px solid var(--contrastColor);
      box-sizing: border-box;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .scs-input {
      width: 100%;
    }

    #contact-search-results {
      padding: 5px 50px;
      box-sizing: border-box;
      width: 60%;
      min-width: 560px;
      height: 350px;
      overflow: scroll;
    }
  }
}
</style>
